// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import govbillEntity from './entities/govbill.json';
import govbillMenu from '../pages/govbill/menu.json';
import govbillFullForm from '../pages/govbill/forms/full.json';
import govbillContextForm from '../pages/govbill/forms/context.json';
import govbillMiniForm from '../pages/govbill/forms/mini.json';
import govbillLookupForm from '../pages/govbill/forms/lookup.json';
import govbillTableView from '../pages/govbill/views/table.json';
import govbillStagesView from '../pages/govbill/views/stages.json';
import govbillCardsView from '../pages/govbill/views/cards.json';
import govbillInlineView from '../pages/govbill/views/inline.json';
import govbillBacklogView from '../pages/govbill/views/backlog.json';
import govbillSplitView from '../pages/govbill/views/split.json';
import govbillCalendarView from '../pages/govbill/views/calendar.json';
import govbillDashboardView from '../pages/govbill/views/dashboard.json';

/** Тип запису «Урядовий законопроєкт» зі сторінками пакета: меню, форми та подання з pages/govbill/. */
export const govbillDefinition: IRecordTypeDefinition = {
  ...govbillEntity,
  views: assembleViewSet({
      table: govbillTableView,
      stages: govbillStagesView,
      cards: govbillCardsView,
      inline: govbillInlineView,
      backlog: govbillBacklogView,
      split: govbillSplitView,
      calendar: govbillCalendarView,
      dashboard: govbillDashboardView,
  }),
  form: govbillFullForm,
  forms: { full: govbillFullForm, context: govbillContextForm, mini: govbillMiniForm, lookup: govbillLookupForm },
  menu: govbillMenu,
} as IRecordTypeDefinition;
